import { Box, styled } from '@mui/material';

export const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
  '& > *': {
    flex: '1 1 0',
    minWidth: 0,
  },
  '& .MuiFormControl-root, & .MuiTextField-root, & .MuiAutocomplete-root': {
    width: '100%',
  },
}));